export default __webpack_public_path__ + "img/city.46c5b09e.svg";